module.exports = __webpack_public_path__ + "img/benjamin-lundy.4aa66cc9.png";